export const PLAN_PRICING = {
  standard: {
    name: 'Standard Pack',
    amount: '$49',
    label: 'USD',
    paymentLink: 'https://rzp.io/rzp/unGegANX',
    users: 1,
    assessments: 3,
  },
  pro: {
    name: 'Pro Pack',
    amount: '$99',
    label: 'USD',
    paymentLink: 'https://rzp.io/rzp/2exK2Y4f',
    users: 3,
    assessments: 5,
  },
};

export const USER_ADD_ONS = {
  standard: {
    amount: '$10',
    paymentLink: 'https://rzp.io/rzp/iNRv9EU',
  },
  pro: {
    amount: '$20',
    paymentLink: 'https://rzp.io/rzp/op2QOyO',
  },
};